var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRightCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.4044C16.1857 20.4044 20.4044 16.1857 20.4044 11.0001C20.4044 5.81453 16.1857 1.59557 11 1.59557C5.81434 1.59557 1.5956 5.81453 1.5956 11.0001C1.5956 16.1857 5.81434 20.4044 11 20.4044ZM11 9.6165e-07C17.0654 4.31399e-07 22 4.93483 22 11.0001C22 17.0654 17.0654 22 11 22C4.93464 22 7.21395e-06 17.0654 6.68371e-06 11.0001C6.15346e-06 4.93484 4.93463 1.4919e-06 11 9.6165e-07Z",
    fill: "#001E64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2841 10.9596L8.95191 13.2918C8.60886 13.6348 8.60886 14.1933 8.95191 14.5363C9.29496 14.8794 9.85342 14.8794 10.1965 14.5363L12.5287 12.2041L13.7733 10.9596L12.5287 9.71504L10.1965 7.38285C9.85342 7.03714 9.29496 7.03714 8.95191 7.38285C8.60886 7.72589 8.60886 8.28434 8.95191 8.62739L11.2841 10.9596Z",
    fill: "#001E64"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightCircleIcon);
export default __webpack_public_path__ + "static/media/chevron_right_circle-icon.f88b2c0d203f495af0d8b58fa848a822.svg";
export { ForwardRef as ReactComponent };